import { Box, List, ListItem, Table, TableCell, TableRow, Typography } from '@mui/material'
import { FC } from 'react'
import ReactMarkdown from 'react-markdown'
import { Link } from 'react-router-dom'
import remarkGfm from 'remark-gfm'
import { QuotingText } from './QuotingText'

type Props = {
    content: string
}

export const DocumentMarkdown: FC<Props> = ({ content }) => {
    return (
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
                p: ({ children }) => (
                    <Typography variant="body2" sx={{ mb: 2 }}>
                        {children}
                    </Typography>
                ),
                h1: ({ children }) => (
                    <Typography variant="h4" sx={{ mb: 2 }}>
                        {children}
                    </Typography>
                ),
                h2: ({ children }) => (
                    <Typography variant="h6" sx={{ mb: 2 }}>
                        {children}
                    </Typography>
                ),
                a: ({ href, children }) => <Link to={`${href}`}>{children}</Link>,
                blockquote: ({ children }) => <QuotingText>{children}</QuotingText>,
                th: ({ children }) => (
                    <TableCell
                        variant="head"
                        sx={{
                            border: '1px solid #5A5F72',
                            p: 1,
                        }}>
                        <Typography variant="body2">{children}</Typography>
                    </TableCell>
                ),
                td: ({ children }) => (
                    <TableCell
                        sx={{
                            border: '1px solid #5A5F72',
                            p: 1,
                        }}>
                        <Typography variant="body2">{children}</Typography>
                    </TableCell>
                ),
                tr: ({ children }) => <TableRow>{children}</TableRow>,
                table: ({ children }) => (
                    <Box
                        sx={{
                            display: 'block',
                            width: '100%',
                            minHeight: 'fit-content',
                            overflowX: 'auto',
                            mb: 2,
                        }}>
                        <Table
                            sx={{
                                border: '1px solid #5A5F72',
                            }}>
                            {children}
                        </Table>
                    </Box>
                ),
                li: ({ children }) => (
                    <ListItem>
                        <Typography variant="body2">{children}</Typography>
                    </ListItem>
                ),
                ul: ({ children }) => <List>{children}</List>,
            }}>
            {content}
        </ReactMarkdown>
    )
}
